import Swiper from "swiper";
export default function LdkSwiper() {
  const ldkElement = document.getElementById(`js_ldk_slide`);
  const ldkSwiper = ldkElement
    ? new Swiper(ldkSwiperElement, ldkSwiperOptions)
    : false;
}

const ldkSwiperElement = `.ldkswiper--container`;
const ldkSwiperOptions = {
  loop: true,
  speed: 500,
  slidesPerView: 1,
  loopAdditionalSlides: 0,
  autoplay: {
    disableOnInteraction: false,
    delay: 5000
  },
  pagination: {
    el: ".swiper-pagination",
    type: "bullets",
    clickable: true
  }
};
